import React from 'react';
import classnames from 'classnames/bind';
import { string, func, number, bool } from 'prop-types';
import styles from './NumeralPagination.css';

const cx = classnames.bind(styles);

const NumeralPageView = props => {
  const { isCurrentPage, onClick, href, page } = props;

  return (
    <li className={cx({ 'active': isCurrentPage })}>
      <a onClick={onClick}
        role="button"
        title={`Page ${page}`}
        href={href}
      >
          {page}
      </a>
    </li>
  );
};

NumeralPageView.propTypes = {
  activeClassName: string,
  href           : string,
  onClick        : func,
  page           : number,
  isCurrentPage  : bool,
};

NumeralPageView.displayName = 'NumeralPageView';

export default NumeralPageView;




// WEBPACK FOOTER //
// ./src/uis/elements/Pagination/NumeralPagination/NumeralPageView.js